import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { RootState, store } from '../..';
import { Tag } from '@/models/tag';
import { tagService } from '@/service/api/tag.service';
import { StudentSearch } from '@/models/student/student-search';
import { studentService } from '@/service/api/student.service';

export interface IStudentFilterState {
  grade: number; // 学年
  schoolClassID: number; // クラスID
  searchWord: string; // 検索ワード
  studentNumber: string; // 学籍番号
  tags: Tag[]; // タグ情報一覧
  selectedTagIDs: number[]; // 選択されたタグ
  targetType: number; // 学年またはクラス絞り込みタイプ(0 or 1)
  targetID: number; // 学年 or クラスID
  latestStudentSearchOptions: StudentSearch; // 直前の検索クエリパラメータ
}
@Module({ dynamic: true, store, name: 'studentFilterModule', namespaced: true })
class StudentFilterModule extends VuexModule implements IStudentFilterState {
  grade: number = 0;
  schoolClassID: number = 0;
  searchWord: string = '';
  studentNumber: string = '';
  tags: Tag[] = [];
  selectedTagIDs: number[] = [];
  targetType: number = 0;
  targetID: number = 0;
  latestStudentSearchOptions: StudentSearch = {};

  get commaSelectedTagIDs(): string {
    return this.selectedTagIDs.join(',');
  }

  @Mutation
  setGrade(value: number) {
    this.grade = value;
  }

  @Mutation
  setSchoolClassID(value: number) {
    this.schoolClassID = value;
  }

  @Mutation
  setSearchWord(value: string) {
    this.searchWord = value;
  }

  @Mutation
  setTags(value: Tag[]) {
    this.tags = value;
  }

  @Mutation
  setTargetType(value: number) {
    this.targetType = value;
  }

  @Mutation
  setTargetID(value: number) {
    this.targetID = value;
  }

  @Mutation
  setLatestStudentSearchOptions(value: StudentSearch) {
    this.latestStudentSearchOptions = value;
  }

  @Mutation
  setStudentNumber(value: string) {
    this.studentNumber = value;
  }

  @Mutation
  setSelectedTagIDs(value: number[]) {
    this.selectedTagIDs = value;
  }

  @Mutation
  clear() {
    this.grade = 0;
    this.schoolClassID = 0;
    this.searchWord = '';
    this.tags = [];
    this.targetType = 0;
    this.targetID = 0;
    this.studentNumber = '';
  }
  /**
   * タグ情報一覧取得
   */
  @Action({ rawError: true })
  async fetchTags(headers: any = {}) {
    const result = await tagService.getTags(headers);
    this.setTags(result);
  }

  @Action({ rawError: true })
  downloadStudentsExcelFile() {
    return studentService.downloadStudentsExcelFile(
      this.latestStudentSearchOptions.targetType,
      this.latestStudentSearchOptions.targetID,
      this.latestStudentSearchOptions.keyword,
      this.latestStudentSearchOptions.studentNumber,
      this.latestStudentSearchOptions.selectedTagIDs
    );
  }
}

export const studentFilterModule = getModule(StudentFilterModule);
